import classNames from 'classnames/bind';
import React from 'react';
import { FormattedPlural, IntlProvider } from 'react-intl';

import Rating from './Rating';
import UserIcon from '../UserIcon';

import s from './index.module.css';

const cx = classNames.bind(s);

const ExpertCard = ({ className, card = {} }) => {
  const {
    name, // string w expert name
    rating, // float w expert rating. Used in calculations of stars amount
    description, // string w expert description
    photoPath, // string w url to expert avatar
    consultations, // number of experts consultations
  } = card;

  return (
    <IntlProvider locale="ru" defaultLocale="ru">
      <div className={cx(s.cardWrapper, { [className]: !!className })}>
        <div className={s.cardContent}>
          <div className={s.cardHeader}>Вас консультирует</div>
          <div className={s.expertName} title={name}>
            {name}
          </div>
          <div className={s.expertDescription} title={description}>
            {description}
          </div>
          <div className={s.expertConsultations}>
            {consultations}&nbsp;
            <FormattedPlural
              value={consultations}
              one={'консультация'}
              few={'консультации'}
              many={'консультаций'}
              other={'консультаций'}
            />
          </div>
          <Rating value={rating} />
        </div>
        <div className={s.photoWrapper}>
          <UserIcon className={s.expertPhoto} icon={photoPath} />
        </div>
      </div>
    </IntlProvider>
  );
};

export default ExpertCard;
